import { reduxBatch } from '@manaflair/redux-batch';
import { configureStore } from '@reduxjs/toolkit';
import { AnyAction } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { ThunkDispatch } from 'redux-thunk';

import { rootReducer } from './RootReducer';

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['socketData', 'fundingRate'],
    whitelist: ['global'],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => [
        ...getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
            thunk: true,
        }),
    ],
    devTools: process.env.NODE_ENV !== 'production',
    enhancers: [reduxBatch],
});

export type RootState = ReturnType<typeof rootReducer>;

export type TypedDispatch<T> = ThunkDispatch<T, any, AnyAction>;

export type AppDispatch = typeof store.dispatch;

/**
 * @see https://github.com/rt2zz/redux-persist#persiststorestore-config-callback
 * @see https://github.com/rt2zz/redux-persist#persistor-object
 */
export const persistor = persistStore(store);

export default store;
